/* eslint-disable libraries/no-restricted-imports */
import { getAnalytics, isSupported } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';

/* eslint-enable libraries/no-restricted-imports */

import _ from 'lodash';
import Config from '@util/config';
import { logger } from '@util/observability';

interface FirebaseAppOptions {
    apiKey: string;
    authDomain: string;
    databaseURL: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    // Firebase Analytics configures GA4 with this ID; index.html loads gtag.js but never calls gtag('config')
    measurementId?: string;
}

const FirebaseAppConfigBase: Omit<FirebaseAppOptions, 'appId' | 'measurementId'> = {
    apiKey: Config.FIREBASE_API_KEY,
    authDomain: 'gamechanger-push-notifications.firebaseapp.com',
    databaseURL: 'https://gamechanger-push-notifications.firebaseio.com',
    projectId: 'gamechanger-push-notifications',
    storageBucket: 'gamechanger-push-notifications.appspot.com',
    messagingSenderId: '376889844239',
};

/**
 * Starts Firebase Analytics, which is what configures GA4 for the app. Independent of feature flags,
 * so it never delays or fails flag initialization.
 */
export const initializeAnalytics = (): void => {
    const logFailure = (error: unknown) =>
        logger.warn('Error initializing Firebase Analytics: ', { error, context: { errorType: 'firebase' } });

    try {
        const app = initializeApp(
            _.merge({}, FirebaseAppConfigBase, {
                appId: Config.FIREBASE_APP_ID,
                measurementId: Config.FIREBASE_MEASUREMENT_ID,
            }),
        );
        isSupported()
            .then((supported) => {
                if (supported) getAnalytics(app);
            })
            .catch(logFailure);
    } catch (error) {
        logFailure(error);
    }
};

// Remote Config is no longer fetched (no flag uses the firebase provider), so firebase flags resolve to their defaults
export const ifInitializedValue = (_flag: string, defaultValue: boolean): boolean => defaultValue;
